import { createGlobalStyle } from "styled-components";

// O toast do design system (useNotification) fica num wrapper `position: fixed` sem z-index e
// sem classe própria; vindo antes do conteúdo no DOM, a página o cobre, e drawers/modais
// (z-index 1000) também. Achamos o wrapper pelo filho (o Snackbar do DS) e o levantamos.
// A classe do Snackbar é um token só ("styles__Notification-sc-1xddo7b-0"), por isso o
// seletor é por atributo e não por ".sc-1xddo7b-0".
// Renderize junto de todo <NotificationProvider>.
const NotificationLayer = createGlobalStyle`
  div:has(> [class*="styles__Notification-sc-1xddo7b-0"]) {
    z-index: 2000;
  }
`;

export default NotificationLayer;
